/**
 * Maps raw edge/RPC error strings to react-intl message ids for AI assistant UI.
 * Never surface raw English server strings to users.
 */
import { userSafeErrorFromT } from './userSafeError';

/**
 * User-safe text to STORE on a failed AI action (`actionResult.error`,
 * `_summaryError`). That field is rendered AND serialized into the LLM history
 * (aiHistoryFormatters), so a raw `err.message` (row values, SQL) must never go in.
 */
export function aiSafeActionError(err) {
  return userSafeErrorFromT(err, undefined, {
    fallbackId: 'aiAssistant.actionError.generic',
    fallbackDefault: "That action didn't go through. Try again.",
  });
}

export function mapAiSummaryErrorToMessageId(raw) {
  if (raw == null || String(raw).trim() === '') return 'aiAssistant.sendSummary.error.generic';
  const s = String(raw).toLowerCase();
  if (s.includes('job not found') && s.includes('access denied')) return 'aiAssistant.sendSummary.error.notFound';
  if (s.includes('not found') && (s.includes('access denied') || s.includes('denied'))) return 'aiAssistant.sendSummary.error.notFound';
  if (s.includes('permission denied') || s.includes('row level security') || /\brls\b/.test(s)) {
    return 'aiAssistant.sendSummary.error.notFound';
  }
  if (s.includes('network') || s.includes('could not reach the server') || s.includes('fetch') || s.includes('failed to fetch')) return 'aiAssistant.sendSummary.error.network';
  if (s.includes('timeout') || s.includes('timed out')) return 'aiAssistant.sendSummary.error.network';
  return 'aiAssistant.sendSummary.error.generic';
}
